import { MetadataSet, ParsedMetadataSet } from '../../../insa-models/meta-data.model'

export function makeParsedMetadataSet(metadataSet: MetadataSet, localize): ParsedMetadataSet {
  return [
    {
      InsaMetaData: metadataSet[0].InsaMetaData,
      InsaMetaDataDetails: metadataSet[0].InsaMetaDataDetails.map(md => ({
        ...md,
        FieldTitle: localize(md.FieldTag) || md.FieldName,
        JavascriptType: databaseToJavascriptType(md.DataType)
      })),
      InsaMetadataFormGroups: metadataSet[0].InsaMetadataFormGroups
    },
    metadataSet[1]
  ]
}

function databaseToJavascriptType(dbtype): 'string' | 'number' | 'boolean' | 'date' {
  switch (dbtype) {
    case 'int':
    case 'real':
    case 'money':
    case 'float':
    case 'decimal':
    case 'smallint':
    case 'tinyint':
    case 'bigint':
    case 'short':
    case 'double':
      return 'number';
    case 'bit':
      return 'boolean';
    case 'datetime':
    case 'timestamp':
    case 'smalldatetime':
      return 'date';
    case 'nvarchar':
    case 'varchar':
    case 'char':
    case 'ntext':
    case 'string':
    default:
      return 'string';
  }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/utils/parsedMetadataSet.ts